import { Box, Stack } from '@mui/material'
import { Dispatch, SetStateAction, useState } from 'react'
import Antelope from 'assets/branding/antelope.svg'
import XMarkIcon from 'assets/icons/nucleo/18px_xmark.svg'
import { CartButton } from 'components/Layout/Header/DisciplineContent/MobileDisciplineContent/CartButton'
import { MagButton } from 'components/Layout/Header/DisciplineContent/MobileDisciplineContent/MagButton'
import { RaceTypeSelector } from 'components/Layout/Header/DisciplineContent/MobileDisciplineContent/RaceTypeSelection/RaceTypeSelector'
import { RaceTypeSelectorButton } from 'components/Layout/Header/DisciplineContent/MobileDisciplineContent/RaceTypeSelection/RaceTypeSelectorButton'
import { minWidthIcon } from 'components/Layout/Header/Header.style'
import { Settings } from 'components/Layout/Header/Settings'
import { Drawer } from 'components/common/Drawer/Drawer'
import { ContactUsButton } from './ContactUsButton'
import { DisconnectButton } from './DisconnectButton'
import { OrganizerButton } from './OrganizerButton'
import { UserButton } from './UserAccountMenu/UserButton'

interface MobileContentProps {
  isOpen: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  allCurrencies: string[]
}

export default function MobileDisciplineContent({
  isOpen,
  setOpen,
  allCurrencies
}: MobileContentProps) {
  const [isSelectingRaceType, setIsSelectingRaceType] = useState(false)

  return (
    <>
      <Drawer
        open={isOpen}
        aria-label="mobile discipline"
        onClose={() => setOpen(false)}
        anchor="right"
        height="100%"
        sx={{
          '& .MuiDrawer-paper': {
            width: '80%',
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px'
          }
        }}
      >
        <Stack justifyContent="space-between" height="100%">
          <Stack>
            <Stack
              flexDirection="row"
              gap={2}
              alignItems="center"
              px={2}
              mt={2}
              mb={2.5}
              height={41}
              width="100%"
              justifyContent="space-between"
            >
              <Antelope style={{ height: '100%' }} />
              <Box p={1.5} />
              <Settings allCurrencies={allCurrencies} />
              <XMarkIcon css={minWidthIcon} onClick={() => setOpen(false)} />
            </Stack>
            <Stack>
              <RaceTypeSelectorButton
                setIsSelectingRaceType={setIsSelectingRaceType}
              />
              <MagButton />
              <OrganizerButton />
            </Stack>
            <Stack
              width="100%"
              py={3}
              px={10}
              justifyContent="center"
              alignItems="center"
              gap={2}
            >
              <UserButton />
              <CartButton withLabel fullWidthOnMobile />
            </Stack>
          </Stack>
          <Stack>
            <ContactUsButton />
            <DisconnectButton />
          </Stack>
        </Stack>
        <RaceTypeSelector
          setIsSelectingRaceType={setIsSelectingRaceType}
          isVisible={isSelectingRaceType}
        />
      </Drawer>
    </>
  )
}
